import LeavableTemplate from '../../html/components/leavable.html'

import Component from '../shared/component'

export const Leavable = Component('v-leavable', {
  template: LeavableTemplate,
  data () {
    return {
      timer: null,
      entered: false
    }
  },
  watch: {
    entered () {
      this.$emit(this.entered ? 'enter' : 'leave')
    }
  },
  methods: {
    enter () {
      clearTimeout(this.timer)

      this.entered = true
      this.timer = null
    },

    leave () {
      this.timer = setTimeout(() => {
        this.entered = false
        this.timer = null
      })
    }
  }
})
